import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FxAmountSyncService } from './fx-amt-sync.service';
import {Subscription} from "rxjs";
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { generalConfigFromGlobal, gridPayloadFromActiveScreen, hydratedGlobalParams, normalizeFilterParams } from '../../../shared/workspace-element-context';


@Component({
    selector: 'gtw-fx-amt-sync',
    templateUrl: './fx-amt-sync.component.html',
    styleUrls: ['./fx-amt-sync.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FxAmtSyncComponent implements OnInit, OnDestroy {
  baseGlobalParams: {
    jcd_key?: string | number;
    tax_year?: string | number;
    scenario?: string | number;
    client_key?: string | number;
    scenarioCode?: string;
    screen_key?: string | number;
    filing_key?: string | number;
    checkLockedbj?: any;
    modalScreen?: { modal_name?: string };
  } | undefined;

  baseURLs: any ={'admin':'','api':'/gtw',"custom":'','efile':'','pdfEngine':'','bulkPdfEngine':''};

  private baseURL = '/custom';
  private baseURLGtw = '/gtw';
  private taxYear :number = 0;
  private scenario :number = 0;
  private jcdKey :number = 0;
  private screenKey :number = 0;
  private ssoId: string = '';
  private filingKey :number = 0;
  private checkLockedObj: any = [];
  private filterParams: any = {};
  private gridData: any = [];
  private scenarioCode: string = '';
  enableButton: boolean = true;
  private modalName: string = '';

  clob_settings: { tax_year: number; scenario: number; jcd_key: number; batch_process: string;} = {
    tax_year: 0,
    scenario: 0,
    jcd_key: 0,
    batch_process: 'N'
  };
  clob_data: any = [];

  @Output('close-fxamtconfirm-info')
  closeFxAmtconfirmInfo = new EventEmitter<string>();

  @Output('save-fxamtsync-info')
  saveFxAmtSyncInfo = new EventEmitter<string>();

  // Standard events consumed by CeHostDialogComponent in the standalone app.
  // Legacy events above are kept for the AngularJS hybrid wrapper in ui/.
  @Output('close-modal')
  closeModal = new EventEmitter<string>();

  @Output('save-and-close')
  saveAndClose = new EventEmitter<any>();

  subscriptions:Subscription = new Subscription() ;

  constructor(
    private FxAmountSyncService: FxAmountSyncService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) { }

  checkInputType():boolean{
		if(Number.isInteger(parseInt(this.taxYear+"")) &&
		  Number.isInteger(parseInt(this.scenario+'')) &&
		  Number.isInteger(parseInt(this.jcdKey +'')) &&
		  Number.isInteger(parseInt(this.screenKey+'')) &&
		  Number.isInteger(parseInt(this.ssoId+""))&&
      Number.isInteger(parseInt(this.filingKey+""))
    )
		{
		  return true;
		}
	
		return false;
	}


  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subscriptions.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
    this.subscriptions.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.init();
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.baseGlobalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.filterParams = normalizeFilterParams(activeScreen) || {};
    this.checkLockedObj = this.baseGlobalParams?.checkLockedbj || this.checkLockedObj;
    this.modalName = activeScreen?.data?.modal_name
      ?? activeScreen?.data?.modalName
      ?? this.baseGlobalParams?.modalScreen?.modal_name
      ?? this.modalName;
    this.taxYear = Number(this.filterParams?.tax_year || this.baseGlobalParams?.tax_year || this.taxYear || 0);
    this.scenario = Number(this.filterParams?.scenario || this.baseGlobalParams?.scenario || this.scenario || 0);
    this.jcdKey = Number(this.filterParams?.jcd_key || this.baseGlobalParams?.jcd_key || this.jcdKey || 0);
    this.screenKey = Number(this.filterParams?.screen_key || this.baseGlobalParams?.screen_key || this.screenKey || 0);
    this.ssoId = this.gtwApp?.USER_SETTINGS?.user?.sso_id || this.ssoId;
    this.gridData = gridPayloadFromActiveScreen(activeScreen)
      ?? activeScreen?.data?.gridData
      ?? activeScreen?.data?.selected
      ?? this.gridData;
  }

  init() {   
    if(this.checkInputType()){
      }
      console.log("gridData------",this.gridData);
    } 


    cancel() {
      console.log("click close");
      this.closeFxAmtconfirmInfo.emit('close-fxamtconfirm-info');
      this.closeModal.emit('close-modal');
      }

    syncfxAmount(){
        this.enableButton = false;
        let processName = 'RUN_SYNC_TB_AMT_CURR_COL';
        this.clob_settings = {
          tax_year: this.taxYear,
          scenario: this.scenario,
          jcd_key: this.jcdKey,
          batch_process: 'N',
        }; 
        let gridObj = {};
        if (this.gridData != undefined && this.modalName == 'triggerFxAmtColumnSync') {
          
          for(var key in this.gridData){
            /*let gridObj : {object_id: string; combination_key: number;} =
            {
              object_id: '',
              combination_key : 0
            };
            
            gridObj["object_id"] = this.gridData[key].data.object_id;
            gridObj["combination_key"] = this.gridData[key].data.COMBINATION_KEY;
*/
                this.clob_data.push([{
                  object_id: this.gridData[key].data.object_id,
                  combination_key: this.gridData[key].data.COMBINATION_KEY
                }
              ]);
           }
        }
        else if(this.modalName == 'triggerFxAmtColumnBatchSync')
        {
            this.clob_settings.batch_process= 'Y';
        }
       
      let updateSubscription = this.FxAmountSyncService.syncFxAmountData(this.baseURLs.api, this.taxYear, this.scenario, this.jcdKey, this.ssoId, processName, 
                                                            this.clob_settings, this.clob_data, this.baseGlobalParams, this.checkLockedObj).subscribe(
            (data) => {
              if (data.callSuccess == "1") {
                this.FxAmountSyncService.openSnackBar('Data Synced Successfully','gtw-snackbar--green');
                this.saveFxAmtSyncInfo.emit('save-fxamtsync-info');
                this.saveAndClose.emit('save-and-close');
              } else {
                this.FxAmountSyncService.openSnackBar('Error syncing Data. '+data.errorMessage, 'gtw-snackbar--red');
                this.enableButton = true;
              }
            },  error => { this.FxAmountSyncService.openSnackBar('Error syncing Data. '+error.error.errorMessage, 'gtw-snackbar--red'); },
            () => { console.log("Update Completed");}
          );
            this.subscriptions.add(updateSubscription);
     };
}
